const ResponsiveTable = () => {
  const tables = document.querySelectorAll("table");
  if (!tables.length) return;
  tables.forEach((table) => {
    var tableWrapper = document.createElement("div");
    tableWrapper.className = "table-responsive";
    table.parentNode.insertBefore(tableWrapper, table);
    tableWrapper.appendChild(table);
  });
};
export default ResponsiveTable;
